

const FooterV4 = () => {
  return (
    <footer className="bg-gradient-to-r from-purple-900 via-purple-800 to-indigo-900 py-12">
      <div className="container max-w-6xl mx-auto px-4">
        <div className="text-center space-y-6">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg">
              <img 
                src="/lovable-uploads/726a2472-43f4-4b0f-ab12-c688c427bf4f.png" 
                alt="Show Up! Logo"
                className="w-10 h-10 object-contain"
              />
            </div>
          </div>

          {/* Contact Section */}
          <div className="mb-8">
            <p className="text-white/90 text-lg mb-2">Questions?</p>
            <p className="text-white/80">
              Contact us at{' '}
              <a 
                href="mailto:contact@showupagain.com" 
                className="text-yellow-400 hover:text-yellow-300 font-medium underline transition-colors duration-200"
              >
                contact@showupagain.com
              </a>
            </p>
          </div>

          {/* Divider */}
          <div className="border-t border-white/20 pt-6">
            {/* Copyright */}
            <p className="text-white/70 text-sm">
              All rights reserved. © 2024 Show Up Inc.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterV4;

